import script from "./NotificationToolTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationToolTip.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationToolTip.vue?vue&type=style&index=0&id=33d9d2b5&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d9d2b5"]])

export default __exports__